/**
 * Converte pagamentos da venda (caixa ou API) para o formato da emissão de NF-e.
 */

function isCrediarioPaymentRow(payment) {
  const name = (payment.payment_method_name || payment.methodLabel || payment.method_name || '').toLowerCase()
  const obs = (payment.observation || '').toLowerCase()
  return (
    payment.isCrediario === true ||
    name.includes('crediário') ||
    name.includes('crediario') ||
    obs.includes('crediário') ||
    obs.includes('crediario') ||
    (payment.status === 'pending' && (name.includes('credi') || obs.includes('credi')))
  )
}

function formatDueDate(value) {
  if (!value) return new Date().toISOString().split('T')[0]
  if (typeof value === 'string' && value.length >= 10) return value.split('T')[0]
  try {
    return new Date(value).toISOString().split('T')[0]
  } catch {
    return new Date().toISOString().split('T')[0]
  }
}

/** Pagamentos lançados no caixa antes de limpar o estado */
export function buildNfePaymentsFromApplied(appliedPayments = []) {
  if (!appliedPayments?.length) return []

  return appliedPayments.map((payment) => {
    if (payment.isCrediario && Array.isArray(payment.installments) && payment.installments.length > 0) {
      return {
        paymentReceiptMethodId: payment.paymentReceiptMethodId,
        paymentTermId: payment.paymentTermId || null,
        amount: parseFloat(payment.amount) || 0,
        isCrediario: true,
        installments: payment.installments.map((inst) => ({
          installmentNumber: inst.installmentNumber,
          dueDate: formatDueDate(inst.dueDate),
          amount: parseFloat(inst.amount) || 0
        })),
        status: 'pending',
        observation: payment.observation || 'Crediário'
      }
    }

    return {
      paymentReceiptMethodId: payment.paymentReceiptMethodId,
      paymentTermId: payment.paymentTermId || null,
      installmentNumber: payment.installments || 1,
      dueDate: formatDueDate(payment.dueDate),
      amount: parseFloat(payment.amount) || 0,
      status: payment.status || 'paid',
      observation: payment.observation || null
    }
  })
}

/** Pagamentos retornados pelo backend (sale_payments) */
export function buildNfePaymentsFromSaleRecords(salePayments = [], accountReceivables = []) {
  if (!salePayments?.length) return []

  return salePayments.map((sp) => {
    const methodId = sp.payment_receipt_method_id || sp.paymentReceiptMethodId
    const amount = parseFloat(sp.amount) || 0

    if (isCrediarioPaymentRow(sp)) {
      const arForSale = accountReceivables.filter(
        (ar) =>
          String(ar.sale_id || ar.saleId || '') === String(sp.sale_id || sp.saleId || '') ||
          (ar.reference_type === 'SALE' && String(ar.reference_id) === String(sp.sale_id))
      )

      const installmentsSource =
        arForSale.length > 0
          ? arForSale
              .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
              .map((ar, idx) => ({
                installmentNumber: idx + 1,
                dueDate: formatDueDate(ar.due_date),
                amount: parseFloat(ar.amount) || 0
              }))
          : []

      if (installmentsSource.length > 0) {
        return {
          paymentReceiptMethodId: methodId,
          paymentTermId: sp.payment_term_id || null,
          amount,
          isCrediario: true,
          installments: installmentsSource,
          status: 'pending',
          observation: sp.observation || 'Crediário'
        }
      }
    }

    return {
      paymentReceiptMethodId: methodId,
      paymentTermId: sp.payment_term_id || null,
      installmentNumber: sp.installment_number || 1,
      dueDate: formatDueDate(sp.due_date),
      amount,
      status: sp.status || 'paid',
      observation: sp.observation || null
    }
  })
}
